import { ProductsDataType } from "@/app/shared/ecommerce/dashboard/stock-report";
import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TableFooter from "@/components/table/footer";
import TablePagination from "@/components/table/pagination";
import { TableClassNameProps } from "@/components/table/table-types";
import { productsData } from "@/data/products-data";
import cn from "@/utils/class-names";
import { exportToCSV } from "@/utils/export-to-csv";
import { productsListColumns } from "./columns";
import Filters from "./filters";

export default function ProductsTable({
    pageSize = 5,
    hideFilters = false,
    hidePagination = false,
    hideFooter = false,
    classNames = {
        container: "border border-muted rounded-md",
        rowClassName: "last:border-0",
    },
    paginationClassName,
}: {
    pageSize?: number;
    hideFilters?: boolean;
    hidePagination?: boolean;
    hideFooter?: boolean;
    classNames?: TableClassNameProps;
    paginationClassName?: string;
}) {
    const { table, setData } = useTanStackTable<ProductsDataType>({
        tableData: productsData,
        columnConfig: productsListColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: pageSize,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
                handleMultipleDelete: (rows) => {
                    setData((prev) => prev.filter((r) => !rows.includes(r)));
                },
            },
            enableColumnResizing: false,
        },
    });

    const selectedData = table
        .getSelectedRowModel()
        .rows.map((row) => row.original);

    function handleExportData() {
        exportToCSV(
            selectedData,
            "ID,Name,Category,Sku,Price,Stock,Status,Rating",
            `product_data_${selectedData.length}`,
        );
    }

    return (
        <>
            {!hideFilters && <Filters table={table} />}
            <Table table={table} variant="modern" classNames={classNames} />
            {!hideFooter && (
                <TableFooter table={table} onExport={handleExportData} />
            )}
            {!hidePagination && (
                <TablePagination
                    table={table}
                    className={cn("py-4", paginationClassName)}
                />
            )}
        </>
    );
}
